
import { classes, style } from 'typestyle'
import { p8 } from '../../../styles/styleset/padding/p8'
import { pb0 } from '../../../styles/styleset/padding/pb0'
import { pb12 } from '../../../styles/styleset/padding/pb12'
import { pt0i } from '../../../styles/styleset/padding/pt0i'
import { pt12 } from '../../../styles/styleset/padding/pt12'

/* Components =================================================================================== */
import { Box } from '../../box/box.component'
import { Text } from '../../text/text.component'
import './style'

export const RichTextView = (props: any) => {
  const { __html, scroll = true, disablePadding = false, className } = props
  const isEmpty = __html === '-' || __html === '<p></p>'

  return (
    <Box
      className={classes(
        'aeki-post',
        !disablePadding && scroll ? p8 : '',
        style({
          $nest: {
            '& ul': {
              paddingLeft: 32,
            },
            '& ol': {
              paddingLeft: 32,
            },
          },
        }),
        !disablePadding && classes(pt12, pb12, pb0, isEmpty && pt0i),
        className,
      )}
      baseline="none"
      fullWidth
      maxHeight={scroll ? 440 : 'initial'}
      style={{
        overflow: scroll ? 'auto' : '',
      }}
    >
      {isEmpty ? (
        '-'
      ) : (
        <Text baseline="surface" size="md" readable>
          <div
            dangerouslySetInnerHTML={{ __html: (__html || '').replace(/<p><\/p>/g, '<br />') }}
          />
        </Text>
      )}
    </Box>
  )
}
